<template>
<!--  -->
<div class="fc compliancebg">
  <top-bar :dataHeader="responseData.topBar"></top-bar>
  <img src="/imgs/complianceLft.png" alt="" class="complianceLft">

  <topbar-base ></topbar-base>
  
  <div class="pr wf hf">
    <transition name="left-side">
      <com-left :resData="responseData" />
    </transition>
    <com-center class="comCenter" :resData="responseData" />
    <transition name="right-side">
      <com-right :resData="responseData" />
    </transition>
  </div>

  <img src="/imgs/complianceRt.png" alt="" class="complianceRt">
  <!-- <img src="/imgs/complianceBtom.png" alt="" class="complianceBtom"> -->
</div>
</template>

<script>
import screenAdjustMixin from '@/views/mixin/screenAdjustMixin'
import topBar from './topbar.vue'
import comLeft from './left'
import comCenter from './center'
import comRight from './right'
import API from "@/api/sascreen-api.js"
import topbarBase from "../components/topbar-base"

export default {
  name: 'enterprise-security',
  components: {
    topbarBase,
    topBar,
    comLeft,
    comCenter,
    comRight
  },
  mixins: [ screenAdjustMixin, ],
  data () {
    return {
      responseData: {
        topBar: {},
        // Left
        energyMonitoring: {},
        pueHistory: {},
        irrUsageCount: {},
        irrUsageHistory: {},
        // Center
        problemCount: {},
        eventList: [],
        // Right
        nsEventCount: {},
        nsEventSource: [],
        nsEventType: [],
        idcActData: {},
        protocolTop: [],
      },
    }
  },
  mounted () {
    this.viewIndex()
    setInterval(() => {
      // API.getMonitordata({module: 'hamiIndex', key:'allUsage'}).then(data => {
      //   this.responseData.allUsage = JSON.parse(data.data.data.allUsage);
      // })
    }, 10000)
  },
  methods: {
    viewIndex () {
      const keys=
        'topBar, energyMonitoring, pueHistory, irrUsageCount, irrUsageHistory,' +
        'problemCount, eventList, ' +
        'nsEventCount, nsEventSource, nsEventType, idcActData, protocolTop'

      API.getMonitordata({module: 'complianceSupervision', key:keys}).then(data => {
        this.responseData = data.data.data
        console.log(this.responseData)
      })
    }
  }
}
</script>
<style>
.compliancebg{
  width: 1920px;
  height: 1080px;
  background: url(/imgs/compliancebg.png) no-repeat;
  position: relative;
}
.side-panel-bg{
  background: rgab(0,0,0,0,0) !important;
}
.complianceLft{
  position: absolute;
  width: 13px;
  height: 1080px;
  left: 0;
}
.complianceRt{
  position: absolute;
 height: 1080px;
  width: 13px;
  right: 0;
}
.complianceBtom{
  position: absolute;
  width: 100%;
  bottom: 0;
}
</style>
